'use client';
import React from 'react';
import SubServices from '../common/sub-services';
import Modal from 'react-modal';
import { InlineWidget } from 'react-calendly';
import MWSVG from '../common/svg';

const MowebOdooDevelopmentServies = () => {
    const customStyles = {
        overlay: {
            zIndex: 9999,
            backgroundColor: 'rgba(0,0,0,0.6)',
            padding: 0,
        },
        content: {
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: '#fff',
            border: '0',
            maxWidth: '600px',
            width: '90%',
            padding: '0',
            paddingTop: '20px',
        },
    };

    const [modalIsOpen, setIsOpen] = React.useState(false);

    const openModal = () => {
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
    };

    return (
        <>
            <div className="section-py bg-grey dark:bg-black">
                <div className="container lg:container mx-auto">
                    <div className="row grid lg:grid-cols-12">
                        <div className="text-center lg:col-span-10 lg:col-start-2 pb-50">
                            <p
                                className="text-primary mb-0 fs-lg fw-700"
                                data-aos="fade-up"
                                data-aos-duration="700"
                                data-aos-delay="200"
                            >
                                Odoo Development Services
                            </p>
                            <h2 data-aos="fade-up" data-aos-duration="700" data-aos-delay="100" className="mb-2.5">
                                Elevate Your Digital Vision with Moweb&apos;s Odoo Development Services
                            </h2>
                            <p>
                                Experience the power of innovation with Moweb&apos;s Odoo development services. Our experts are
                                ready to turn your project ideas into cutting-edge digital solutions using Enterprise Software
                                Solutions.
                            </p>
                        </div>
                    </div>
                    <div className="row grid xl:grid-cols-3 lg:grid-cols-2 md:grid-cols-2">
                        <SubServices
                            path={'/img/technology/ic-odoo-customization.svg'}
                            height={64}
                            width={64}
                            alt="customization"
                            title="customization"
                            serviceName="Fortify Your Data: Securing Your Success"
                            serviceDescription="Protecting your data is non-negotiable. We prioritize the confidentiality of your information through stringent Non-Disclosure Agreements (NDAs), ensuring the security of your project at every step."
                        />
                        <SubServices
                            path={'/img/technology/ic-odoo-implementation.svg'}
                            height={64}
                            width={64}
                            alt="implementation"
                            title="implementation"
                            serviceName="Strategize for Success: Your Goals, Our Blueprint"
                            serviceDescription="Collaborate with our team to outline your project goals. With a clear roadmap in place, we dive into action, working diligently to bring your vision to life."
                        />
                        <SubServices
                            path={'/img/technology/ic-odoo-integration.svg'}
                            height={64}
                            width={64}
                            alt="integration"
                            title="integration"
                            serviceName="Design Brilliance: Beyond Aesthetics"
                            serviceDescription="Designing isn't just about looks—it's about creating an intuitive and engaging user experience. Our design experts focus on functionality, usability, and aesthetics to deliver a seamless digital journey."
                        />
                        <SubServices
                            path={'/img/technology/ic-odoo-migration.svg'}
                            height={64}
                            width={64}
                            alt="migration"
                            title="migration"
                            serviceName="Code for Excellence: Building Strong Foundations"
                            serviceDescription="Just like constructing a sturdy building, well-written code forms the backbone of your digital product. Our development team ensures clean, efficient, and scalable code for optimal performance."
                        />
                        <SubServices
                            path={'/img/technology/ic-odoo-support.svg'}
                            height={64}
                            width={64}
                            alt="support"
                            title="support"
                            serviceName="Launch with Impact: Making Waves in the Digital Space"
                            serviceDescription="The time has come to unveil your masterpiece. We orchestrate a flawless deployment, generating momentum and setting the stage for your digital success"
                        />
                        <SubServices
                            path={'/img/technology/ic-odoo-consulting.svg'}
                            height={64}
                            width={64}
                            alt="consulting"
                            title="consulting"
                            serviceName="Continuous Support: Your Partner in Growth"
                            serviceDescription="Our commitment doesn't end at launch. We provide comprehensive support and maintenance services, ensuring your digital solution evolves and stays ahead of the curve."
                        />
                    </div>
                    <div className="row grid lg:grid-cols-12 mt-10">
                        <div className="text-center lg:col-span-12">
                            <div
                                className="card p-5 md:p-5 lg:p-30 bg-white dark:bg-black rounded-10 border"
                                data-aos="fade-up"
                                data-aos-duration="700"
                                data-aos-delay="300"
                            >
                                <h2 className="mb-5">Ready to Transform? Let&apos;s Begin Your Digital Journey!</h2>
                                <button
                                    aria-labelledby="odooExpertLabel"
                                    className="btn btn-primary self-baseline"
                                    onClick={() => {
                                        openModal();
                                    }}
                                >
                                    Talk to Odoo Expert
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={customStyles}>
                <div onClick={closeModal} className="text-secondary text-right btn-close absolute left-5 cursor-pointer pt-5">
                    <MWSVG id="ic_close" svgClassName="text-secondary" />
                </div>
                <InlineWidget
                    styles={{
                        height: '100%',
                    }}
                    url="https://calendly.com/mowebsales/moweb-sales"
                />
            </Modal>
        </>
    );
};

export default MowebOdooDevelopmentServies;
